// Define tag type enum for type safety
export var TagType;
(function (TagType) {
    TagType["TEXT"] = "text";
    TagType["FILE_NAME"] = "fileName";
    TagType["ALLOW_EDIT"] = "allowEdit";
    TagType["CONFIDENCE"] = "confidence";
})(TagType || (TagType = {}));
//# sourceMappingURL=TagType.js.map